import { ProductMenu as WorkdayProductMenu } from '@workday/platform-kernel-wired-ui';

import { ProductMenuApp } from '~/components/PageLayout/types';

interface Props {
  apps?: ProductMenuApp[];
}

export const ProductMenu = ({ apps }: Props) => {
  if (!apps?.length) {
    return null;
  }
  return <WorkdayProductMenu items={apps} />;
};
